module.exports = __webpack_public_path__ + "static/media/unlimited_plan.417ab2d7.svg";